import React from 'react'

import { Form, Col } from '_zari/core'

const CodigoSerieFormGroup = ({ value }) => {
  return (
    <Form.Group>
      <Form.Label text='SERIE' htmlFor='input-codigoSerie-2' md={4} />
      <Col md={8}>
        <Form.InputText value={value} disabled id='input-codigoSerie-2' />
      </Col>
    </Form.Group>
  )
}

export default CodigoSerieFormGroup
